import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export const money = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const pct = (n) => (n === null || n === undefined ? "—" : `${Number(n).toFixed(2).replace(/\.?0+$/, "")}%`);

export const cleanTerritory = (t) => (t || "").replace(/^\.\.+/, "");

export const fmtWhen = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
};

export const fmtBytes = (n) => {
  if (!n) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
};

export const kindLabel = (r) => ({
  legacy_import: "Legacy import", bundle_export: "Export bundle", bundle_import: "Import bundle",
}[r?.kind] || `Stax sync (${r?.mode})`);

export const apiError = (e, fallback) =>
  toast.error(formatApiErrorDetail(e?.response?.data?.detail) || fallback || "Something went wrong");

export const useCanManage = (user) =>
  (user?.role || "").toLowerCase() === "super_admin" ||
  (Array.isArray(user?.permissions) && user.permissions.includes("commissions.edit"));

export const isSuperAdmin = (user) => (user?.role || "").toLowerCase() === "super_admin";

export const thCls = "px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500 whitespace-nowrap";
export const tdCls = "px-3 py-2 align-top";
export const numCls = "px-3 py-2 text-right tabular-nums whitespace-nowrap";
